var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-page',{attrs:{"page-title":"Bill Profile","page-icon":"mdi-arrow-decision-outline","collection-name":"billProfile","module":"bill","items-per-page":20,"add-dialog-title":"Add Bill Profile","is-filter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }